import { t } from '@/plugins/i18n'
import { ref, reactive, computed } from 'vue'
import { getArea } from '@/apis/shopcart'
import {
  getClearanceAddressList,
  addClearance,
  setDefaultClearanceAddress
} from '@/apis/address'

export const getAreaTxt = (row: { area: any }, provinces: any) => {
  const t: any = (provinces || []).find((e: any) => e.intAreaId === row.area)
  return t?.label
}

export const getCityTxt = (row: { area: any; city: any }, provinces: any) => {
  const t: any = (provinces || []).find((e: any) => e.intAreaId === row.area)
  if (t) {
    const v = t.children.find((e: { intAreaId: any }) => e.intAreaId === row.city)
    return v?.label
  } else {
    return ''
  }
}
export default (form: any, wareType?:string) => {
  interface iAddressConfig {
    visible: boolean,
    title: string,
    list: any[],
    columns: any[],
    defaultForm: any
    id: string
  }

  const clearanceAddressConfig: iAddressConfig = reactive({
    visible: false,
    title: t('选择清关地址'),
    list: [],
    columns: [
      {
        align: 'center',
        slotName: 'checked',
        width: '40'
      },
      {
        label: t('姓名'),
        prop: 'receiveName',
        align: 'center'
      },
      {
        label: t('公司名'),
        prop: 'company',
        align: 'center',
        slotName: 'company'
      },
      {
        label: t('会社编号'),
        prop: 'companyCode',
        align: 'center'
      },
      {
        label: t('联系电话'),
        prop: 'phone',
        align: 'center'
      },
      {
        label: t('都道府县'),
        prop: 'area',
        align: 'center',
        slotName: 'area'
      },
      {
        label: t('邮箱'),
        prop: 'email',
        align: 'center',
        slotName: 'email'
      },
      {
        label: t('市'),
        prop: 'city',
        align: 'center',
        slotName: 'city'
      },
      {
        label: t('区町村-详细地址'),
        prop: 'address',
        align: 'center'
      },
      {
        label: t('邮编'),
        prop: 'postalCode',
        align: 'center',
        slotName: 'postalCode'
      },
      {
        label: t('操作'),
        prop: 'action',
        align: 'center',
        slotName: 'action'
      }
    ],
    defaultForm: {
      receiveName: '',
      companyName: '',
      companyCode: '',
      country: '+81',
      phone: '',
      area: '',
      city: '',
      address: '',
      postalCode: '',
      receiveNameEn: '',
      companyNameEn: '',
      areaEn: '',
      cityEn: '',
      addressEn: '',
      defaultAddress: 0
    },
    id: 'shopClearanceAddressId'
  })
  const showClearanceAddress = computed(() => {
    return clearanceAddressConfig?.list.length > 0
  })
  const selectClearanceAddress = ref()
  const selectClearanceAddressFn = (id: any) => {
    const defaultAddress = clearanceAddressConfig.list.find((e: any) => e.shopClearanceAddressId === id)
    selectClearanceAddress.value = defaultAddress
    form.declarationAddress = defaultAddress
  }
  const refreshClearanceList = () => {
    getClearanceAddressList({
      exportCountry: wareType ?? 'CN'
    }).then((res: { data: any[] }) => {
      clearanceAddressConfig.list = res.data
      const defaultAddress = clearanceAddressConfig.list.find((e: { defaultAddress: any }) => !!e.defaultAddress)
      form.declarationAddress = defaultAddress || clearanceAddressConfig.list[0]
      selectClearanceAddress.value = defaultAddress || clearanceAddressConfig.list[0]
    })
  }

  refreshClearanceList()

  const openClearanceAddressVisible = () => {
    clearanceAddressConfig.visible = true
  }

  const provinces = ref()
  getArea({ type: 0 }).then((res) => {
    provinces.value = res.data
  })

  return {
    showClearanceAddress,
    clearanceAddressConfig,
    addClearance,
    setDefaultClearanceAddress,
    openClearanceAddressVisible,
    provinces,
    selectClearanceAddress,
    selectClearanceAddressFn,
    refreshClearanceList
  }
}
